import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Megaphone, X, ArrowRight } from "lucide-react";

const STORAGE_KEY = "cc_ann_dismissed";

export default function AnnouncementBar() {
  const [ann, setAnn] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/announcements?limit=1");
        const a = data?.[0];
        if (!a) return;
        let dismissed = [];
        try { dismissed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch {}
        if (dismissed.includes(a.announcement_id)) return;
        setAnn(a);
      } catch {}
    })();
  }, []);

  if (!ann) return null;

  const dismiss = () => {
    try {
      const ids = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      ids.push(ann.announcement_id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(-20)));
    } catch {}
    setAnn(null);
  };

  return (
    <div className="bg-[#111] text-white" data-testid="announcement-bar">
      <Link
        to="/browse"
        className="block hover:bg-[#1a1a1a] transition-colors"
        data-testid="announcement-cta"
      >
        <div className="max-w-[1400px] mx-auto px-3 sm:px-6 lg:px-10 py-1.5 sm:py-2 flex items-center gap-2 sm:gap-3 text-[12px] sm:text-sm">
          <Megaphone className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#ff4500] shrink-0" strokeWidth={1.75} />
          <span className="mono text-[10px] sm:text-[11px] tracking-widest text-[#ff4500] font-bold shrink-0">NEW</span>
          <span className="flex-1 min-w-0 truncate">{ann.title}</span>
          <span className="inline-flex items-center gap-1 text-[#ff4500] mono text-[10px] sm:text-xs shrink-0">
            Explore <ArrowRight className="w-3 h-3" />
          </span>
          <button
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); dismiss(); }}
            aria-label="Dismiss"
            data-testid="announcement-dismiss"
            className="shrink-0 text-white/70 hover:text-white"
          >
            <X className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
          </button>
        </div>
      </Link>
    </div>
  );
}
